import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Timeline() {
  const { t } = useTranslation();
  const events = t('nis2Timeline.events', { returnObjects: true }) || [];

  return (
    <div className="bg-[#E9E9E9] p-10 rounded-lg">
      <div className="grid grid-cols-5">
        {events.map((event, index) => (
          index % 2 === 0 ? (
            <div key={index} className="flex flex-col">
              <div className="flex flex-col items-start">
                <h3 className="font-semibold text-gray-800">{event.title}</h3>
                <p className="text-sm text-gray-600">{event.date}</p>
                <p className="mt-1 text-xs text-gray-600 max-w-xs">{event.description}</p>
              </div>
            </div>
          ) : (
            <div key={index} />
          )
        ))}
      </div>

      <div className="my-10 w-full justify-center items-center h-1 bg-gray-300 grid grid-cols-5">
        {events.map((event, index) => (
          <div key={index} className="relative w-full place-items-center grid">
            <div className="absolute w-4 h-4 bg-yellow-400 border-4 border-gray-700 rounded-full">
              {index % 2 === 0 ? (
                <div className="absolute -translate-y-7 left-1/2 -translate-x-1/2 h-6 w-1 bg-gray-300 z-0" />
              ) : null}
              {index % 2 !== 0 ? (
                <div className="absolute translate-y-3 left-1/2 -translate-x-1/2 h-6 w-1 bg-gray-300 z-0" />
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-5">
        {events.map((event, index) => (
          index % 2 !== 0 ? (
            <div key={index} className="flex flex-col">
              <div className="flex flex-col items-start">
                <h3 className="font-semibold text-gray-800">{event.title}</h3>
                <p className="text-sm text-gray-600">{event.date}</p>
                <p className="mt-1 text-xs text-gray-600 max-w-xs">{event.description}</p>
              </div>
            </div>
          ) : (
            <div key={index} />
          )
        ))}
      </div>
    </div>
  );
}
// (example usage removed)

